import { web3 } from 'fbonds-core'

export const LRTS_MINT = new web3.PublicKey('4tARAT4ssRYhrENCTxxZrmjL741eE2G23Q1zLPDW2ipf')
export const SSOL_MINT = new web3.PublicKey('sSo14endRuUbvQaJS3dq36Q829a3A6BEfoeeRGJywEh')
export const SOLAYER_STAKE_POOL = new web3.PublicKey('po1osKDWYF9oiVEGmzKA4eTs8eMveFRMox3bUKazGN2')
